import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/common/ScrollToTop";

export const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main data-testid="app-main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
